export default "__VITE_ASSET__BdPNlrve__"